import history from '../store/history'

const useHistory = () => {
  return history
}

export default useHistory
